module.exports = __webpack_public_path__ + "273aa251a2cced4bc445f5d29a785eb0.svg";